import type { ComponentPropsWithoutRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ColorBrandBlue1 } from 'autogen/design-tokens/tokens';
import { Product360 } from 'autogen/translation-keys/trans-website-product';
import type { Product360MediaItem } from 'components/GalleryMediaPreviewer/shared/types';
import Image from 'components/generic/Image';
import dynamic from 'helpers/dynamic';
import { MediaCarouselItem } from '../../GalleryThumbnailCarousel';

const ThumbnailImage = styled(Image.WithScaling)`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const Arrow360Icon = dynamic(() => import('icons/Arrow360.svg?react'), { ssr: false });

const IconContainer = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    width: 32px;
    top: 50%;
    left: 50%;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    background-color: ${ColorBrandBlue1};
`;

export default function ThumbnailGallery360Item({
    product360Item: { thumbnail },
    isActive,
    ...restProps
}: { product360Item: Product360MediaItem; isActive: boolean } & ComponentPropsWithoutRef<'button'>) {
    const { t } = useTranslation();

    return (
        <MediaCarouselItem $isActive={isActive} {...restProps}>
            <ThumbnailImage
                src={thumbnail}
                sizes={118}
                transformType="ThumbnailScale"
                imageType="product"
                loading="lazy"
                alt={t(Product360)}
            />
            <IconContainer>
                <Arrow360Icon fill="white" width={24} height={24} />
            </IconContainer>
        </MediaCarouselItem>
    );
}
